import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from '@mui/material';
import * as fileApi from '../../../lib/api/file';
import NoticeFileList from '../../../components/dashboard/notice/NoticeFileList';
import { listNoticeFiles, unloadNoticeFiles } from '../../../modules/dashboardModule/noticeFiles';

const NoticeFileListContainer = ({ notice }) => {
    const dispatch = useDispatch();

    //redux selection
    const { files, error, loading } = useSelector(
        ({ dashboardModule, loading }) => ({
            files: dashboardModule.noticeFiles.files,
            error: dashboardModule.noticeFiles.error,
            loading: loading['dashboard/LIST_NOTICE_FILES'],
        }),
    );
    //useEfffect

    const handleClick = (id) => (event) => {
        event.stopPropagation();
        onDownLoad(id);
    };
   
    const onDownLoad = async (param) => {
        fileApi.downloadNew(param);
    };

useEffect(() => {
    if (notice) {
        dispatch(listNoticeFiles('notice', notice.wrUuid));
    }

        //언마운트될때 리덕스에서 파트너 데이터 초기화
        return () => {
            dispatch(unloadNoticeFiles());
        };
    }, [notice]);

    const columns = useMemo(
        () => [
            {
                field: 'id',
                headerName: 'ID',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileUuid',
                headerName: '파일코드',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileTyp',
                headerName: '파일타입',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileAttrVal1',
                headerName: '공지ID',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileAttrVal2',
                headerName: '파일 타입',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileAttrVal3',
                headerName: '파일참고2',
                hide: true,
                type: 'string',
                editable: false,
                filterable: false,
            },
            {
                field: 'fileNm',
                headerName: '파일명',
                minWidth: 300,
                flex: 1,
                editable: false,
                filterable: false,
                renderCell: (params) => (
                    <Link
                        href="#"
                        onClick={handleClick(params)}
                        
                    >
                        {params.value}
                    </Link>
                ),
            },
            {
                field: 'fileDesc',
                headerName: '참고사항',
                minWidth: 400,
                flex: 1,
                type: 'string',
                editable: false,
            },
        ],
        [],
    );

    return (
        <div>
            <NoticeFileList
                columns={columns}
                files={files}
                error={error}
                loading={loading}
            />
        </div>
    )
}

export default NoticeFileListContainer